var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { useGlobalContext, evictCache, currentTripStateIdVar, usePageRouting, TripType, FlightJourneyType, useUpdateHolidayFlight, } from '@honeycomb/data';
import { trackFunnelAction, FunnelAction } from '@honeycomb/tracking';
import { Stacker, Clone, Button, useDisclosure } from '@honeycomb/ui-core';
import { hotelSRPRouting } from '@honeycomb/routing';
import { FlightCard } from '../flight/FlightCard/FlightCard';
import { FlightDetailsDialog } from '../flight/FlightDetails/FlightDetailsDialog';
import { FlightModificationDialog } from '../flight/FlightModificationDialog/FlightModificationDialog';
import { SingleFlightResultNotification } from './SingleFlightResultNotification';
import { FlightSearchNoResults } from './FlightSearchNoResults';
export function FlightSearchResults({ flightResults: flightSearchResults, action: { fetchNextFlights, selectFlight }, tripState, flightSelected, onResetFilters, }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { loading: flightsLoading, called: flightsCalled, error, data } = flightSearchResults;
    const { data: basketData, loading: tripStateLoading } = tripState;
    const loading = flightsLoading || !flightsCalled || tripStateLoading;
    const basket = ((_a = basketData === null || basketData === void 0 ? void 0 : basketData.getTripState) === null || _a === void 0 ? void 0 : _a.basket) || {};
    const hotelItinerary = (_c = (_b = basket === null || basket === void 0 ? void 0 : basket.hotelProducts) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.itinerary;
    const hotelNights = (hotelItinerary === null || hotelItinerary === void 0 ? void 0 : hotelItinerary.nights) || 0;
    const { resourceStrings: { FLIGHTS_LOADMORE }, } = useGlobalContext();
    const flights = (_d = data === null || data === void 0 ? void 0 : data.flightSearchResults) === null || _d === void 0 ? void 0 : _d.flights;
    const { isPageRouting } = usePageRouting();
    const totalFlightCount = (_f = (_e = data === null || data === void 0 ? void 0 : data.flightSearchResults) === null || _e === void 0 ? void 0 : _e.totalFlights) !== null && _f !== void 0 ? _f : 0; // The total number of flights in the result set.
    const filteredFlightCount = (_h = (_g = data === null || data === void 0 ? void 0 : data.flightSearchResults) === null || _g === void 0 ? void 0 : _g.filteredFlights) !== null && _h !== void 0 ? _h : 0; // The number of flights that match the current filter settings.
    const visibleFlightCount = (_j = flights === null || flights === void 0 ? void 0 : flights.length) !== null && _j !== void 0 ? _j : 0; // The number of hotels that we are currently displaying.
    const [updateHolidayFlight, updateHolidayFlightResult] = useUpdateHolidayFlight([
        () => {
            hotelSRPRouting();
        },
    ]);
    const [flightModificationDialogOpen, { open: handleOpenFlightModificationDialog, close: handleCloseFlightModificationDialog },] = useDisclosure(false);
    const [chosenFlightResult, setChosenFlightResult] = React.useState(null);
    const [preSelectedFlight, setPreSelectedFlight] = React.useState();
    const [selectedIndex, setSelectedIndex] = React.useState(null);
    const tripType = (_k = basketData === null || basketData === void 0 ? void 0 : basketData.getTripState.searchParameters) === null || _k === void 0 ? void 0 : _k.tripType;
    const flightJourneyType = (_l = basketData === null || basketData === void 0 ? void 0 : basketData.getTripState.searchParameters) === null || _l === void 0 ? void 0 : _l.flightJourneyType;
    useEffect(() => {
        const preSelectedFlightData = flights &&
            flights.find((flight) => {
                return flight.isPreSelected === true;
            });
        if (preSelectedFlightData) {
            setPreSelectedFlight(preSelectedFlightData);
        }
    }, [flights, preSelectedFlight]);
    const [flighDetailsDialogOpen, setFlighDetailsDialogOpen] = React.useState(false);
    const [flightDetails, setFlightDetails] = React.useState();
    const handleSelectFlight = (flightResult, index) => __awaiter(this, void 0, void 0, function* () {
        var _m, _o;
        trackFunnelAction(FunnelAction.SELECT_FLIGHT, tripType !== null && tripType !== void 0 ? tripType : TripType.Holiday);
        if ((_m = flightResult.checkInAdjustment) === null || _m === void 0 ? void 0 : _m.dayDifferenceHotelNotAvailable) {
            setSelectedIndex(index);
            evictCache('ROOT_QUERY', 'hotelSearchResults', false);
            evictCache('ROOT_QUERY', 'hotelAvailability', false);
            evictCache('ROOT_QUERY', 'flightSearchResults', false);
            updateHolidayFlight({
                request: {
                    flightId: (_o = flightResult.flightId) !== null && _o !== void 0 ? _o : '',
                    newCheckInDate: flightResult.checkInAdjustment.dayDifferenceHotelCheckIn,
                    newHotelSearchId: flightResult.checkInAdjustment.dayDifferenceHotelSearchId,
                    tripStateId: currentTripStateIdVar(),
                },
            });
            return;
        }
        const { checkInAdjustment } = flightResult;
        const dayDifferenceHotelNights = (checkInAdjustment === null || checkInAdjustment === void 0 ? void 0 : checkInAdjustment.dayDifferenceHotelNights) || 0;
        const hasNightDifference = dayDifferenceHotelNights > 0 && hotelNights !== dayDifferenceHotelNights;
        if (hasNightDifference) {
            setChosenFlightResult(flightResult);
            handleOpenFlightModificationDialog();
            return;
        }
        if (selectFlight) {
            selectFlight({
                request: {
                    flightId: flightResult.flightId || '',
                    tripStateId: currentTripStateIdVar(),
                },
            });
        }
        setSelectedIndex(index);
    });
    if (error) {
        return React.createElement("div", null,
            "Error!: ",
            error.message);
    }
    if (!loading && (filteredFlightCount === 0 || totalFlightCount === 0)) {
        return React.createElement(FlightSearchNoResults, { hasFiltered: totalFlightCount !== 0, onResetFilters: onResetFilters });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Stacker, { spacing: { xs: 5, xl: 6 } },
            flights && !tripStateLoading && (React.createElement(React.Fragment, null,
                flights.map((item, index) => {
                    const chosenFlight = index === selectedIndex;
                    return (React.createElement(FlightCard, { flightResult: item, selected: item.isPreSelected, onSelect: (event) => {
                            event.preventDefault();
                            handleSelectFlight(item, index);
                        }, onShowFlightDetails: () => {
                            setFlightDetails({
                                outboundLeg: item === null || item === void 0 ? void 0 : item.outboundLeg,
                                inboundLeg: item === null || item === void 0 ? void 0 : item.inboundLeg,
                                isOpenJawLeg: item === null || item === void 0 ? void 0 : item.isOpenJaw,
                            });
                            setFlighDetailsDialogOpen(true);
                        }, ctaProps: {
                            loading: (flightSelected && chosenFlight) ||
                                (updateHolidayFlightResult.loading && chosenFlight),
                            disabled: (flightSelected && !chosenFlight) ||
                                isPageRouting ||
                                (updateHolidayFlightResult.loading && !chosenFlight),
                        }, priceDisplayMode: tripType === TripType.Flight ? 'total' : 'delta', "data-id": `flight_card_${index}_container`, key: item.flightId, oneWayFlight: tripType === TripType.Flight && flightJourneyType === FlightJourneyType.Oneway }));
                }),
                flights.length === 1 && React.createElement(SingleFlightResultNotification, null))),
            loading && React.createElement(Clone, { copies: 6, renderChildren: () => React.createElement(FlightCard, { "data-id": "flight-card-skeleton" }) }),
            !loading && visibleFlightCount < filteredFlightCount && (React.createElement(Button, { onClick: fetchNextFlights, fullWidth: true, variant: "outlined", size: "l", color: "primary", "data-id": "show_more_button" }, FLIGHTS_LOADMORE))),
        React.createElement(FlightDetailsDialog, { outboundLeg: (flightDetails === null || flightDetails === void 0 ? void 0 : flightDetails.outboundLeg) || undefined, inboundLeg: (flightDetails === null || flightDetails === void 0 ? void 0 : flightDetails.inboundLeg) || undefined, open: flighDetailsDialogOpen, onClose: () => {
                setFlighDetailsDialogOpen(false);
            }, isOpenJaw: flightDetails === null || flightDetails === void 0 ? void 0 : flightDetails.isOpenJawLeg, showHolidayFlightModMessage: false, showInclusion: true }),
        React.createElement(FlightModificationDialog, { flightResult: chosenFlightResult || undefined, open: flightModificationDialogOpen, onClose: handleCloseFlightModificationDialog, hotelItinerary: hotelItinerary, selectHolidayFlight: selectFlight, flightSelected: flightSelected })));
}
